import React from 'react';
import { hydrate } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { HydrateConfig, GetValues } from './Config/MyAppConfig';
import { ThemeProvider, StyledEngineProvider } from '@mui/material';
import { theme } from './Theme';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';

HydrateConfig();

export const appInsights = new ApplicationInsights({
    config: {
        connectionString: GetValues().AppInsightsConnectionString,
        excludeRequestFromAutoTrackingPatterns: ["rs.fullstory.com", "px.ads.linkedin.com", "edge.fullstory.com", "sdk-04.moengage.com", "maps.googleapis.com"]
    }
});

appInsights.loadAppInsights();
appInsights.trackEvent({ name: "Startup" });

function Main() {
    
    const [hasMounted, setHasMounted] = React.useState(false);
    
    React.useEffect(() => {
      setHasMounted(true);
      const jssStyles = document.querySelector('#jss-server-side');
      if (jssStyles && jssStyles.parentElement) {
        jssStyles.parentElement.removeChild(jssStyles);
      }
    }, []);

    if (!hasMounted) return null;
  
    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </ThemeProvider>
        </StyledEngineProvider>
    );
}

if (typeof document !== 'undefined') hydrate(<Main />, document.getElementById('root'));

if (module.hot) {
    module.hot.accept();
}
